import React, { Component } from "react";
import { connect } from "react-redux";

import ModalSignatario from "../../components/Modais/ModalSignatario";
import ModalHistorico from "../../components/Modais/ModalHistorico";
import ModalPDF from "../../components/Modais/ModalPDF";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Modal from "react-modal";

import {
  selected_doc_remove,
  contatarSignatario,
  removeSigDoc,
  buscaDocumento,
  select_doc,
  baixarDocumento,
  exibirEvidencia,
  showInfoSignatario,
  getCarimbo,
  changeStatus,
} from "../../actions";
import ModalStatus from "../../components/Modais/ModalStatus";
import ModalEvidencia from "../../components/Modais/ModalEvidencia";

class Sobre_doc extends Component {
  constructor() {
    super();

    this.state = {
      modalSigOpen: false,
      modalHisOpen: false,
      modalPDFOpen: false,
      modalRemoveSig: false,
      modalStatus: false,
      loading_gerar_carimbo: false,
      sigSelect: undefined,

      tipoModalSig: "adicionar",
      statusOperacao: "",
    };
  }

  componentDidMount() {
    window.feather.replace(); // carrega icons do bootstrap
  }

  componentDidUpdate() {
    window.feather.replace();
  }

  modalSig(tipo = "adicionar", doc_id = undefined, sig_id = undefined) {
    this.setState({
      doc_id,
      sig_id,
      tipoModalSig: tipo,
      modalSigOpen: !this.state.modalSigOpen,
    });
  }

  modalHistorico() {
    this.setState({ modalHisOpen: !this.state.modalHisOpen });
  }

  modalPDF() {
    this.setState({ modalPDFOpen: !this.state.modalPDFOpen });
  }

  modalRmSig(doc_id = null, id_sig = null) {
    //modal remove signatario
    this.setState({
      doc_id,
      id_sig,
      modalRemoveSig: !this.state.modalRemoveSig,
    });
  }

  modalStatus(statusOperacao = "") {
    this.setState({ statusOperacao, modalStatus: !this.state.modalStatus });
  }

  contatarSignatario(doc_id, sig_id, tipo) {
    this.setState({ sigSelect: sig_id });

    this.props.contatarSignatario(doc_id, sig_id, tipo, (err) => {
      const { sig_contatar_msg } = this.props.documentos;
      if (err) toast.error(sig_contatar_msg || "Erro ao enviar notificação");
      else toast.success(sig_contatar_msg);
    });
  }

  removeSigDoc() {
    const { doc_id, sig_id } = this.state;
    //if(window.confirm('Deseja realmente excluir este signatario?')){
    this.setState({ sigSelect: sig_id, modalSigOpen: false });

    this.props.removeSigDoc(doc_id, sig_id, (err) => {
      const { sig_remove_msg } = this.props.documentos;

      if (!err) toast.error(sig_remove_msg);
      else {
        //this.props.buscaDocumento(doc_id)
        document.querySelector(`[name=sig${sig_id}]`).remove();
        toast.success(sig_remove_msg);
      }
    });
    // }
  }

  carimboErrorHandler = (documento, error_doc) => {
    // mandar gerar de novo o carimbo
    // forçar o download
    // changeStatus
    this.setState({ loading_gerar_carimbo: true });
    this.props.changeStatus(
      documento.id,
      "finalizado",
      documento.dataLimite,
      (err) => {
        this.props.getCarimbo(documento.id, (success) => {
          const { error_doc } = this.props.documentos;
          toast.error();
          if (!success) toast.error(error_doc);
          this.setState({ loading_gerar_carimbo: false });
          // else toast.success('Download iniciará em breve!')
        });
      },
      true
    );
  };

  downloadDoc(tipo = "documento original") {
    const { documento } = this.props.documentos;

    switch (tipo) {
      case "carimbo":
        this.props.getCarimbo(documento.id, (success) => {
          const { error_doc } = this.props.documentos;

          if (!success) {
            toast.success("Aguarde, seu download iniciará em breve");
            this.carimboErrorHandler(documento);
          } else toast.success("Download iniciará em breve!");
        });
        break;
      case "documento":
        this.props.baixarDocumento(documento, "documento", (error) => {
          const { error_doc } = this.props.documentos;

          if (error) toast.error(error_doc);
          else toast.success("Download iniciará em breve!");
        });
        break;
      case "documento original":
        this.props.baixarDocumento(documento, "documento_original", (error) => {
          const { error_doc } = this.props.documentos;

          if (error) toast.error(error_doc);
          else toast.success("Download iniciará em breve!");
        });
        break;

      default:
        toast("Ainda não implementado!");
        break;
    }
  }

  returnStatus(doc) {
    var frase = "Em processo até " + doc.dataLimite;
    var color = "warning";
    const status = doc.status || "";

    if (status.toLowerCase().search(/assinado|finalizado/gi) > -1) {
      frase = doc.status;
      color = "success";
    } else if (status.toLowerCase().includes("cancelado")) {
      frase = doc.status;
      color = "danger";
    }

    return <p className={`badge badge badge-${color}`}>{frase}</p>;
  }

  returnAssinaturas(assinaturas) {
    if (assinaturas == undefined) return "0/0";
    return assinaturas.replace("Assinaturas:", "").trim();
  }

  render() {
    const { admin, gerente } = this.props.auth.user;
    const isAdmin = admin;
    const isGerente = gerente;

    const { loading_gerar_carimbo } = this.state;
    const { documento, sig_load, load_doc, load_carimbo } =
      this.props.documentos;

    const { isDocumentoGerenciado, isManipulaDocumento } = documento;

    const docFinalizado =
      (documento.status || "").toLowerCase().search(/assinado|finalizado/gi) >
        -1 || (documento.status || "").toLowerCase().includes("cancelado");

    const permissaoManipulacao =
      !docFinalizado &&
      ((isDocumentoGerenciado && isManipulaDocumento) ||
        !isDocumentoGerenciado);
    const permissaoManipulacaoGerencial =
      !docFinalizado &&
      ((isDocumentoGerenciado && isManipulaDocumento) ||
        (isGerente && isManipulaDocumento) ||
        isAdmin);

    if (documento.signatarios == undefined) {
      documento["signatarios"] = [];
    }

    return (
      <main role="main" className="col-md-10 ml-sm-auto col-lg-10 px-3">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb mt-3 ">
            <li className="breadcrumb-item">
              <a href="#" onClick={() => this.props.selected_doc_remove()}>
                Documentos
              </a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              {documento.titulo}
            </li>
          </ol>
        </nav>

        <div className=" p-3 bg-white rounded shadow-sm">
          <div className="row">
            <div className="col">
              <div className="media ">
                <div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <span data-feather="file" className=""></span>
                    <h3
                      className="mr-0"
                      style={{ marginBottom: 0, marginLeft: 5 }}
                    >
                      {documento.titulo}
                    </h3>
                  </div>
                  <div>
                    {documento.tag && (
                      <span
                        style={{
                          marginLeft: 0,
                          textTransform: "uppercase",
                          fontSize: 12,
                        }}
                        className={`badge badge-primary`}
                      >
                        {documento.tag}
                      </span>
                    )}
                    {documento.numero && (
                      <span
                        style={{
                          marginLeft: 5,
                          textTransform: "uppercase",
                          fontSize: 12,
                        }}
                        className={`badge`}
                      >
                        {documento.numero}
                      </span>
                    )}
                  </div>
                  <small>Adicionado em {documento.created_at} </small>
                  <br />
                  {this.returnStatus(documento)}
                </div>
              </div>

              <div className="mt-3">
                {permissaoManipulacao && (
                  <button
                    style={customStyle.button}
                    type="button"
                    className="btn btn-success mb-1"
                    data-toggle="modal"
                    data-target="#modalStatus"
                    onClick={() => this.modalStatus("finalizado")}
                  >
                    Finalizar
                  </button>
                )}
                {permissaoManipulacao && (
                  <button
                    style={customStyle.button}
                    type="button"
                    className="btn btn-danger mb-1"
                    data-toggle="modal"
                    data-target="#modalStatus"
                    onClick={() => this.modalStatus("cancelado")}
                  >
                    Cancelar
                  </button>
                )}
                <button
                  style={customStyle.button}
                  type="button"
                  className="btn btn-info mb-1"
                  data-toggle="modal"
                  data-target="#modalSeeDoc"
                >
                  Visualizar
                </button>
                <button
                  style={customStyle.button}
                  type="button"
                  className="btn btn-secondary mb-1"
                  data-toggle="modal"
                  data-target="#modalLog"
                >
                  Histórico
                </button>

                <button
                  style={customStyle.button}
                  id="downloadDoc"
                  type="button"
                  className="btn btn-primary dropdown-toggle mb-1"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  disabled={load_doc || loading_gerar_carimbo || load_carimbo}
                >
                  {load_doc || load_carimbo || loading_gerar_carimbo ? (
                    <span
                      style={{ marginRight: 10 }}
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  ) : null}
                  Baixar
                </button>

                {/* <button  style={customStyle.button} id="downloadDoc" type="button" className="btn btn-dark mb-1"
                                    onClick={() => this.downloadDoc('carimbo')} disabled={load_carimbo}>
                                    {load_carimbo?<span style={{marginRight:10}} className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>:null}
                                    Baixar Carimbo
                                </button> */}

                <div className="dropdown-menu" aria-labelledby="downloadDoc">
                  {documento.possuiDocumentoOriginal && (
                    <a
                      style={{ cursor: "pointer" }}
                      className="dropdown-item"
                      onClick={() => this.downloadDoc("documento original")}
                    >
                      Documento Original
                    </a>
                  )}
                  <a
                    style={{ cursor: "pointer" }}
                    className="dropdown-item"
                    onClick={() => this.downloadDoc("documento")}
                  >
                    Documento Certificado
                  </a>
                  {docFinalizado && (
                    <a
                      style={{ cursor: "pointer" }}
                      className="dropdown-item"
                      onClick={() => this.downloadDoc("carimbo")}
                    >
                      Carimbo do tempo
                    </a>
                  )}
                  {/* <a style={{cursor:'pointer'}} className="dropdown-item" onClick={ () => this.downloadDoc('documento original e assinado')}>Documento original e assinado</a> */}
                </div>
              </div>
            </div>
            <div className="col text-center">
              <img
                className=""
                src="/assets/imagem/document.png"
                alt=""
                width="180"
                height="180"
              />
            </div>
          </div>
        </div>

        <div className="my-3 p-3 bg-white rounded shadow-sm">
          <h5 className="pb-2">
            Lista de signatários (
            {this.returnAssinaturas(documento.assinaturas)})
          </h5>

          {permissaoManipulacaoGerencial && (
            <button
              type="button"
              className="btn btn-primary"
              data-toggle="modal"
              data-target="#modalSignatario"
              onClick={() => this.modalSig()}
            >
              Adicionar Signatário
            </button>
          )}

          {/* <!-- Lista de sginatarios --> */}

          {documento.signatarios.map((v, i) => {
            const status = v.pivot.status || "";
            const tipoStyle =
              status.toLowerCase().search(/assinado|finalizado/gi) > -1
                ? "success"
                : "warning";
            const imgStatus =
              status.toLowerCase().search(/assinado|finalizado/gi) > -1
                ? "concluido.png"
                : status.toLowerCase().includes("cancelado")
                ? "cancelado.png"
                : "clock.png";
            return (
              <div className="mt-3" key={"sig" + v.id} name={"sig" + v.id}>
                <div className="row border border-gray rounded p-1 no-gutters">
                  {v.url_selfie && (
                    <div
                      className="col-xs-4 col-sm-4 col-md-4 col-lg-2 text-left"
                      style={{ margin: "auto" }}
                    >
                      <img
                        style={{ marginRight: "1%", borderRadius: "2%" }}
                        className=" "
                        src={v.url_selfie}
                        alt=""
                        /*width="150"*/ height="120"
                      />
                    </div>
                  )}

                  {v.url_selfie && (
                    <div className="col-xs-4 col-sm-4 col-md-4 col-lg-6 text-left">
                      <img
                        style={{ marginRight: "1%" }}
                        className=" "
                        src={`/assets/imagem/${imgStatus}`}
                        alt=""
                        width="30"
                        height="30"
                      />
                      {v.nome}
                      {/* <br /> */}
                      <small className="text-muted">
                        {" (" + v.pivot.tipo + ")"}
                      </small>
                      <br />
                      <span className={`badge badge-pill badge-${tipoStyle}`}>
                        {v.pivot.status}{" "}
                        {tipoStyle == "success" ? v.pivot.assinado_em : ""}
                      </span>
                      <br />
                      <span>{"Validação SERPRO solicitada? "}</span>
                      <span style={{ fontWeight: "bold" }}>
                        {v.pivot.realizarValidacaoFacial === "S"
                          ? "Sim"
                          : "Não"}
                      </span>
                      <br />
                      <span>{"CPF existe na SERPRO: "}</span>
                      {v.biometriaFacial.cpfDisponibilidade === "S" && (
                        <span style={{ color: "green", fontWeight: "bold" }}>
                          Sim
                        </span>
                      )}
                      {v.biometriaFacial.cpfDisponibilidade === "N" && (
                        <span style={{ color: "red", fontWeight: "bold" }}>
                          Não
                        </span>
                      )}
                      {v.biometriaFacial.cpfDisponibilidade !== "S" &&
                        v.biometriaFacial.cpfDisponibilidade !== "N" && (
                          <span style={{ fontWeight: "bold" }}>
                            Sem registro
                          </span>
                        )}
                      <br />
                      <span>{"Biometria facial existe na SERPRO: "}</span>
                      {v.biometriaFacial.faceDisponibilidade === "S" && (
                        <span style={{ color: "green", fontWeight: "bold" }}>
                          Sim
                        </span>
                      )}
                      {v.biometriaFacial.faceDisponibilidade === "N" && (
                        <span style={{ color: "red", fontWeight: "bold" }}>
                          Não
                        </span>
                      )}
                      {v.biometriaFacial.faceDisponibilidade !== "S" &&
                        v.biometriaFacial.faceDisponibilidade !== "N" && (
                          <span style={{ fontWeight: "bold" }}>
                            Sem registro
                          </span>
                        )}
                      <br />
                      <span>{"Similaridade da biometria facial: "}</span>
                      {v.biometriaFacial.faceProbabilidade &&
                        v.biometriaFacial.faceProbabilidade.includes("Alt") && (
                          <span style={{ color: "green", fontWeight: "bold" }}>
                            {v.biometriaFacial.faceProbabilidade} (
                            {v.biometriaFacial.faceSimilaridade})
                          </span>
                        )}
                      {v.biometriaFacial.faceProbabilidade &&
                        v.biometriaFacial.faceProbabilidade.includes(
                          "Baix"
                        ) && (
                          <span style={{ color: "red", fontWeight: "bold" }}>
                            {v.biometriaFacial.faceProbabilidade} (
                            {v.biometriaFacial.faceSimilaridade})
                          </span>
                        )}
                      {(!v.biometriaFacial.faceProbabilidade ||
                        (!v.biometriaFacial.faceProbabilidade.includes(
                          "Baix"
                        ) &&
                          !v.biometriaFacial.faceProbabilidade.includes(
                            "Alt"
                          ))) && (
                        <span style={{ fontWeight: "bold" }}>Sem registro</span>
                      )}
                    </div>
                  )}

                  {!v.url_selfie && (
                    <div className="col-xs-8 col-sm-8 col-md-8 col-lg-8 text-left">
                      <img
                        style={{ marginRight: "1%" }}
                        className=" "
                        src={`/assets/imagem/${imgStatus}`}
                        alt=""
                        width="30"
                        height="30"
                      />
                      {v.nome}
                      {/* <br /> */}
                      <small className="text-muted">
                        {" (" + v.pivot.tipo + ")"}
                      </small>
                      <br />
                      <span className={`badge badge-pill badge-${tipoStyle}`}>
                        {v.pivot.status}{" "}
                        {tipoStyle == "success" ? v.pivot.assinado_em : ""}
                      </span>
                      <br />
                      <br />
                    </div>
                  )}

                  {/* <div className="col-md" style={{ display:'none' }}> */}
                  {/* Nome preenchido diverge do nome cadastrado na base de dados da Receita Federal.
                                            (Vitor Souza Vieira) */}
                  {/* </div> */}

                  {sig_load && v.id == this.state.sigSelect ? (
                    <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4 text-center">
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      >
                        <span className="sr-only">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4 text-right">
                      <button
                        onClick={async () => {
                          await this.props.showInfoSignatario(v);
                          this.setState({
                            tipoModalSig: "infos",
                            modalSigOpen: !this.state.modalSigOpen,
                          });
                        }}
                        style={{
                          ...customStyle.buttonActionSig,
                          marginRight: "1%",
                        }}
                        id="infoSignatario"
                        type="button"
                        className="btn btn-primary mb-1"
                        data-toggle="modal"
                        data-target="#modalSignatario"
                      >
                        Info.Signatário
                      </button>

                      {status.toLowerCase().search(/assinado|finalizado/gi) >
                      -1 ? (
                        <button
                          className="btn btn-secondary mb-1"
                          data-toggle="modal"
                          data-target="#modalEvidence"
                          style={{
                            ...customStyle.buttonActionSig,
                            marginRight: "1%",
                          }}
                          onClick={() =>
                            this.props.exibirEvidencia(v.cpfCnpj, documento.id)
                          }
                        >
                          Evidência
                        </button>
                      ) : null}

                      {permissaoManipulacaoGerencial && (
                        <button
                          style={{
                            ...customStyle.buttonActionSig,
                            marginRight: "1%",
                          }}
                          type="button"
                          className="btn btn-danger mb-1"
                          data-toggle="modal"
                          data-target="#modalSignatario"
                          onClick={() =>
                            this.modalSig("remove", documento.id, v.id)
                          }
                        >
                          Remover
                        </button>
                      )}

                      {status
                        .toLowerCase()
                        .search(/assinado|finalizado|cancelado/gi) == -1 &&
                        permissaoManipulacao && (
                          <button
                            style={customStyle.buttonActionSig}
                            id="contatoDropDown"
                            type="button"
                            className="btn btn-primary dropdown-toggle mb-1"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                          >
                            Enviar <span data-feather="send"></span>
                          </button>
                        )}

                      <div
                        className="dropdown-menu"
                        aria-labelledby="contatoDropDown"
                      >
                        <a
                          style={{ cursor: "pointer" }}
                          className="dropdown-item"
                          onClick={() =>
                            this.contatarSignatario(documento.id, v.id, "email")
                          }
                        >
                          Enviar E-mail
                        </a>
                        <a
                          style={{ cursor: "pointer" }}
                          className="dropdown-item"
                          onClick={() =>
                            this.contatarSignatario(documento.id, v.id, "sms")
                          }
                        >
                          Enviar SMS
                        </a>
                        {permissaoManipulacaoGerencial && (
                          <a
                            style={{ cursor: "pointer" }}
                            className="dropdown-item"
                            onClick={() =>
                              this.contatarSignatario(
                                documento.id,
                                v.id,
                                "whatsapp"
                              )
                            }
                          >
                            Enviar WhatsApp
                          </a>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            );
          })}

          {documento.signatarios.length == 0 ? (
            <div className="mt-3">
              <div className="row border border-gray rounded p-3 no-gutters">
                <div className="col text-center text-muted">
                  <span data-feather="user"></span>
                  Ainda não possui signatários
                </div>
              </div>
            </div>
          ) : null}
        </div>
        {true ? (
          <ModalSignatario
            removeSigDoc={() => this.removeSigDoc()}
            tipo={this.state.tipoModalSig}
            closeModal={() => this.modalSig()}
          />
        ) : null}

        {true ? (
          <ModalHistorico
            loading_gerar_carimbo={this.state.loading_gerar_carimbo}
            carimboErrorHandler={this.carimboErrorHandler}
            closeModal={() => this.modalHistorico()}
          />
        ) : null}

        {true ? <ModalPDF closeModal={() => this.modalPDF()} /> : null}

        {true ? (
          <ModalStatus
            closeModal={() => this.modalStatus()}
            status={this.state.statusOperacao}
          />
        ) : null}
        {true ? <ModalEvidencia /> : null}
        <ToastContainer
          autoClose={3000}
          position={toast.POSITION.BOTTOM_CENTER}
          draggable={false}
        />
      </main>
    );
  }
}

const mapStateToProps = ({ documentos, auth }) => {
  return {
    auth,
    documentos,
  };
};

export default connect(mapStateToProps, {
  selected_doc_remove,
  contatarSignatario,
  removeSigDoc,
  buscaDocumento,
  select_doc,
  baixarDocumento,
  exibirEvidencia,
  showInfoSignatario,
  getCarimbo,
  changeStatus,
})(Sobre_doc);

const customStyle = {
  button: {
    margin: "0.5%",
  },
  buttonActionSig: {
    height: 40,
  },
};
